import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import TextArea from 'antd/es/input/TextArea';
import { FormHeader, FormItem, FormSubmitButtonConatainer, RowWrapper } from 'component/form_component/style';
import { createGroupData } from 'redux/slices/getOuGroups';
import { Form, Input, Radio, Select, Tabs } from 'antd';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import {
  CreateContendwrap,
  CreateFormwrap,
  CreateStyleDiv,
  Createwrap,
} from 'component/create_ou_component/create_childOu_components/style';
import { useRefreshGroupTab } from 'component/table_component/groupData/refreshGroupData';
import TransferDataComponent from 'component/form_component/transferDataBox';
import TabPane from 'antd/es/tabs/TabPane';
import { getGroupsExceptUser } from 'redux/slices/usersGroupSlice';
import { getChildOuDropdown, getDomainContainers } from 'redux/slices/getChildOu';
import { getUserNotInGroupData } from 'redux/slices/getUserNotInGroup';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { ReactComponent as UserIcon } from 'assets/images/SVG/icons/user-icon.svg';
import { ReactComponent as GroupIcon } from 'assets/images/SVG/icons/group-header-icon.svg';
import { InputPatternRuleAD } from 'utils/input_pattern';
import Swal from 'sweetalert2';

export default function CreateGroup() {
  const refreshGroupTab = useRefreshGroupTab();
  const selectedNode = useSelector((state) => state.selectedNode);
  const { childOuDropdown, domainContainers } = useSelector((state) => state.getChildOuData);
  const location = useLocation();
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [formTab1] = Form.useForm();
  const [activeTab, setActiveTab] = useState('1');
  const [loading, setLoading] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [assignedGroups, setAssignedGroups] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const adminOuName = useSelector((state) => state.ouTreeData.data);
  const { groupsExceptUser } = useSelector((state) => state.usersGroupSlice);
  const { userNotInGroup } = useSelector((state) => state.getUserNotInGroupData);

  useEffect(() => {
    let initialOuName = '';
    let fqdn = selectedNode.domainName ?? localStorage.getItem('domain');
    if (localStorage.getItem('role') === 'ouadmin') {
      initialOuName = adminOuName.dnName;
    } else {
      initialOuName =
        selectedNode.selectedNode && selectedNode.domainDn ? selectedNode.domainDn : localStorage.getItem('domainDn');
    }
    dispatch(
      getGroupsExceptUser({
        fqdn: fqdn,
        userName: '',
        ouName: initialOuName,
      })
    );
    dispatch(
      getUserNotInGroupData({
        groupName: '',
        fqdn: fqdn,
        ouName: initialOuName,
      })
    );
    dispatch(
      getChildOuDropdown({
        fqdn: fqdn,
        ouName: initialOuName,
      })
    );
    dispatch(getDomainContainers(fqdn));
  }, [selectedNode]);

  useEffect(() => {
    form.setFieldsValue({
      fqdn: selectedNode.domainName,
    });
  }, [selectedNode, form]);

  useEffect(() => {
    if (selectedNode.selectedNode) {
      form.setFieldsValue({ ouName: selectedNode.typeOfData === 'domain' ? null : selectedNode.selectedNode.dnName });
    }
    if (!initialRender && location.pathname === '/create_group') {
      Navigate('/groupdata');
    } else {
      setInitialRender(false);
    }
  }, [selectedNode]);

  let userMergedArray = [];
  if (userNotInGroup.length > 0) {
    userMergedArray = userNotInGroup.map((group, index) => ({
      groupAvailability: true,
      title: group.name,
      dn: group.distinguishedName,
      key: index + 1,
      disabled: group.isbuiltin,
      render: () => (group.type === 'person' ? <UserIcon /> : <GroupIcon />),
    }));
  }

  let groupMergedArray = [];
  if (groupsExceptUser.length > 0) {
    groupMergedArray = groupsExceptUser.map((group, index) => ({
      groupAvailability: true,
      title: group.groupName,
      dn: group.distinguishedName,
      key: index + 1,
    }));
  }
  const handleUserTransferChange = (addedData, direction, removedData) => {
    setAssignedUsers(addedData);
  };
  const handleGroupTransferChange = (addedData, direction, removedData) => {
    setAssignedGroups(addedData);
  };
  const handleNameChange = () => {
    const groupName = form.getFieldValue('groupName');
    const displayName = `${groupName || ''}`;
    form.setFieldsValue({
      groupNamePreWin: displayName && displayName.trim(),
    });
  };
  const onFinish = async (values) => {
    const addGroupNames = assignedGroups.map((name) => name.dn);
    const username = assignedUsers.map((name) => name.dn);
    if (values.ouName === selectedNode.selectedNode.name) {
      values.ouName = selectedNode.selectedNode.dnName;
    } else if (!values.ouName) {
      if (selectedNode.typeOfData !== 'ou') {
        values.ouName = selectedNode.selectedNode.dnName;
      }
    }
    let inputValue = values.groupNamePreWin;
    if (inputValue.match(InputPatternRuleAD.pattern)) {
      const result = await Swal.fire({
        icon: 'info',
        html: `The Group Name (Pre Win 2000) ${inputValue} ${InputPatternRuleAD.message}`,
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        showCancelButton: true,
        cancelButtonColor: 'green',
        width: '500px',
        heightAuto: false,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: {
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
      });
      if (result.isConfirmed) {
        inputValue = inputValue.replace(InputPatternRuleAD.pattern, '_');
        form.setFieldsValue({
          groupNamePreWin: inputValue,
        });
        values.groupNamePreWin = inputValue;
      } else {
        return;
      }
    }
    values.fqdn = selectedNode.domainName;
    const groupData = values;
    const value = {
      groupData,
      addGroupNames,
      username,
    };
    try {
      setLoading(true);
      const sweetAlert = await dispatch(createGroupData(value));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        Navigate('/groupdata');
      } else if (sweetAlert.payload && sweetAlert.payload.response.status === 409) {
        SweetSweetAlert({ sweetData: sweetAlert.payload.response.data, icon: 'warning', buttonColor: 'orange' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
    refreshGroupTab();
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  return (
    <Createwrap className='af-outer-wrap af-creategroup-outer-wrap'>
      <CreateStyleDiv className='af-wrap af-creategroup-wrap'>
        <BackButton to='/groupdata' className='af-back-button af-creategroup-back-button'>
          <LeftArrowIcon className='af-back-button-icon af-creategroup-back-button-icon' /> Back
        </BackButton>
        <CreateContendwrap className='af-content-wrap af-creategroup-content-wrap'>
          <CreateFormwrap className='af-form-wrap af-creategroup-form-wrap'>
            {loading && <ModalOpenLoader />}
            <FormHeader className='af-form-header af-creategroup-form-header'>Create New Group</FormHeader>
            <Form
              className='af-form af-creategroup-form'
              form={form}
              layout='vertical'
              name='register'
              onFinish={onFinish}
              initialValues={{
                groupName: '',
                groupNamePreWin: '',
                ouName: null,
                email: '',
                description: '',
                groupScopes: 2,
                groupTypes: 1,
                notes: '',
              }}
              scrollToFirstError
              size='large'
            >
              <Tabs
                className='af-form-tab af-creategroup-form-tab'
                activeKey={activeTab}
                defaultActiveKey='1'
                onChange={handleTabChange}
                tabPosition='top'
                tabBarGutter={20}
              >
                <TabPane
                  tab='Account'
                  key='1'
                  className='af-form-tab af-creategroup-form-tab af-creategroup-form-tab-tabpane af-creategroup-form-tab-tabpane_account'
                >
                  <RowWrapper className='af-form-row-wrapper af-creategroup-form-row-wraper af-creategroup-form-row-wraper-wrap1'>
                    <FormItem
                      className='af-form-item af-creategroup-form-item af-creategroup-form-item-groupname'
                      key='groupName'
                      name='groupName'
                      label='Group Name'
                      rules={[
                        {
                          required: true,
                          message: `Please enter the group name`,
                        },
                      ]}
                    >
                      <Input
                        onChange={handleNameChange}
                        className='af-form-input af-creategroup-form-input af-creategroup-form-input_groupname'
                      />
                    </FormItem>
                    <FormItem
                      key='groupNamePreWin'
                      name='groupNamePreWin'
                      label='Group Name (Pre Win 2000)'
                      className='af-form-item af-creategroup-form-item af-creategroup-form-item-groupname_prewin'
                    >
                      <Input className='af-form-input af-creategroup-form-input af-creategroup-form-input_groupname_prewin' />
                    </FormItem>
                  </RowWrapper>
                  <RowWrapper className='af-form-row-wrapper af-creategroup-form-row-wraper af-creategroup-form-row-wraper-wrap3'>
                    {selectedNode.typeOfData !== 'builtinDomain' && (
                      <FormItem
                        key='ouName'
                        name='ouName'
                        label='OU'
                        className='af-form-item af-creategroup-form-item af-creategroup-form-item-ou'
                      >
                        <Select
                          allowClear
                          showSearch
                          placeholder='Select a Ou'
                          className=' af-form-select af-creategroup-form-select af-creategroup-form-select_ou'
                        >
                          {domainContainers
                            .filter(
                              (container) =>
                                typeof container === 'object' && container.distinguishedName.includes('CN=Users')
                            )
                            .map((container) => (
                              <Select.Option
                                className='af-form-select-option af-creategroup-form-select-option'
                                key={container.distinguishedName}
                                value={container.distinguishedName}
                              >
                                {container.name} (Container)
                              </Select.Option>
                            ))}
                          {localStorage.getItem('role') === 'ouadmin' && (
                            <Select.Option
                              className='af-form-select-option af-creategroup-form-select-option'
                              key={adminOuName.dnName}
                              value={adminOuName.dnName}
                            >
                              {adminOuName.name}
                            </Select.Option>
                          )}
                          {childOuDropdown.map((ou) => (
                            <Select.Option
                              className='af-form-select-option af-creategroup-form-select-option'
                              key={ou.dnName}
                              value={ou.dnName}
                            >
                              {ou.name}
                            </Select.Option>
                          ))}
                        </Select>
                      </FormItem>
                    )}
                    <FormItem
                      className={`${
                        selectedNode.typeOfData === 'builtinDomain' ? 'oddFormItem' : ''
                      } af-form-item af-creategroup-form-item af-creategroup-form-item-email`}
                      key='email'
                      name='email'
                      label='E-mail'
                      rules={[
                        {
                          type: 'email',
                          message: `Please enter the valid e-mail`,
                        },
                      ]}
                    >
                      <Input className='af-form-input af-creategroup-form-input af-creategroup-form-input_email' />
                    </FormItem>
                  </RowWrapper>
                  <RowWrapper className='af-form-row-wraper af-creategroup-form-row-wraper af-creategroup-form-row-wraper-wrap4'>
                    <FormItem
                      key='groupScopes'
                      name='groupScopes'
                      label='Group Scope'
                      className='af-form-item af-creategroup-form-item af-creategroup-form-item-groupscope'
                    >
                      <Radio.Group className='af-form-radio af-creategroup-form-radio af-creategroup-form-radio_groupscope'>
                        <Radio
                          className='af-form-radio-option af-creategroup-form-radio-option af-creategroup-form-radio-option_groupscope'
                          value={1}
                        >
                          Domain Local
                        </Radio>
                        <Radio
                          className='af-form-radio-option af-creategroup-form-radio-option af-creategroup-form-radio-option_groupscope'
                          value={2}
                        >
                          Global
                        </Radio>
                        <Radio
                          className='af-form-radio-option af-creategroup-form-radio-option af-creategroup-form-radio-option_groupscope'
                          value={3}
                        >
                          Universal
                        </Radio>
                      </Radio.Group>
                    </FormItem>
                    <FormItem
                      key='groupTypes'
                      name='groupTypes'
                      label='Group Type'
                      className='af-form-item af-creategroup-form-item af-creategroup-form-item-grouptypes'
                    >
                      <Radio.Group className='af-form-radio af-creategroup-form-radio af-creategroup-form-radio_grouptype'>
                        <Radio
                          className='af-form-radio-option af-creategroup-form-radio-option af-creategroup-form-radio-option_grouptype'
                          value={1}
                        >
                          Security
                        </Radio>
                        <Radio
                          className='af-form-radio-option af-creategroup-form-radio-option af-creategroup-form-radio-option_grouptype'
                          value={2}
                        >
                          Distribution
                        </Radio>
                      </Radio.Group>
                    </FormItem>
                  </RowWrapper>
                  <RowWrapper className='af-form-row-wraper af-creategroup-form-row-wraper af-creategroup-form-row-wraper-wrap5'>
                    <FormItem
                      key='description'
                      name='description'
                      label='Description'
                      className='af-form-item af-creategroup-form-item af-creategroup-form-item-description'
                    >
                      <TextArea
                        rows={2}
                        className='af-form-input af-creategroup-form-input af-creategroup-form-textarea_description'
                      />
                    </FormItem>
                    <FormItem
                      key='notes'
                      name='notes'
                      label='Notes'
                      className='af-form-item af-creategroup-form-item af-creategroup-form-item-notes'
                    >
                      <TextArea
                        rows={2}
                        className='af-form-textarea af-creategroup-form-textarea af-creategroup-form-textarea_description'
                      />
                    </FormItem>
                  </RowWrapper>
                </TabPane>
                <TabPane
                  tab='Group Members'
                  key='2'
                  className='af-creategroup-form-tab af-creategroup-form-tab af-creategroup-form-tab-tabpane af-creategroup-form-tab-tabpane_groupmembers'
                >
                  <FormItem
                    label='Group Members'
                    className='af-form-item af-creategroup-form-item af-creategroup-form-item-groupmembers'
                  >
                    <Form className='af-form af-creategroup-form af-creategroup-form-groupmembers' form={formTab1}>
                      <TransferDataComponent
                        className='af-creategroup-transferbox af-creategroup-transferbox-groupmembers'
                        leftBoxData={userMergedArray}
                        rightBoxData={[]}
                        onChange={handleUserTransferChange}
                        leftBoxTitle={'Members Not in Group'}
                        rightBoxTitle={'Members of this Group'}
                        height={500}
                      />
                    </Form>
                  </FormItem>
                </TabPane>
                <TabPane
                  tab='Member Of'
                  key='3'
                  className='af-form-tab af-creategroup-form-tab af-creategroup-form-tab-tabpane af-creategroup-form-tab-tabpane_memberof'
                >
                  <FormItem
                    label='Assign Group'
                    className='af-form-item af-creategroup-form-item af-creategroup-form-item-assigngroup'
                  >
                    <TransferDataComponent
                      className='af-creategroup-transferbox af-creategroup-transferbox-assigngroup'
                      leftBoxData={groupMergedArray}
                      rightBoxData={[]}
                      onChange={handleGroupTransferChange}
                      leftBoxTitle={'Available Group(s)'}
                      rightBoxTitle={'Assigned Group(s)'}
                      height={500}
                    />
                  </FormItem>
                </TabPane>
              </Tabs>
              <FormSubmitButtonConatainer className='af-form-button-submit-wrapper af-creategroup-form-button-submit-wrapper'>
                <StyledButton
                  type='primary'
                  htmlType='submit'
                  className='af-form-button af-creategroup-form-button af-creategroup-form-button_submit'
                >
                  Submit
                </StyledButton>
              </FormSubmitButtonConatainer>
            </Form>
          </CreateFormwrap>
        </CreateContendwrap>
      </CreateStyleDiv>
    </Createwrap>
  );
}
